module.exports = __webpack_public_path__ + "media/icons/arrow-left-square@3x-ecf1111a.svg";